import { View } from 'react-native';
import { styled } from '../../styled';
export default styled(View, {
    py: '$1',
    w: '100%',
    alignItems: 'center',
}, {
    componentName: 'ActionsheetIndicatorWrapper',
});
